import { Component } from '@/types/component';
import { cn } from '@/utils/cn';
import { StandaloneEdge, StandaloneEdgeProps } from 'base/components/Edge';
import localFonts from 'next/font/local';

const fontPrimary = localFonts({
  src: [
    { path: '../../../public/fonts/source-sans-3-500-normal.woff2', weight: '500', style: 'normal' },
    {
      path: '../../../public/fonts/source-sans-3-500-italic.woff2',
      weight: '500',
      style: 'italic',
    },
    { path: '../../../public/fonts/source-sans-3-700-normal.woff2', weight: '700', style: 'normal' },
  ],
  display: 'swap',
  preload: true,
  variable: '--font-primary',
});

const fontSecondary = localFonts({
  src: [
    { path: '../../../public/fonts/source-serif-4-400-normal.woff2', weight: '400', style: 'normal' },
    { path: '../../../public/fonts/source-serif-4-700-normal.woff2', weight: '700', style: 'normal' },
    {
      path: '../../../public/fonts/source-serif-4-400-italic.woff2',
      weight: '400',
      style: 'italic',
    },
  ],
  display: 'swap',
  preload: false,
  variable: '--font-secondary',
});

const fontTertiary = localFonts({
  src: [
    { path: '../../../public/fonts/lora-600-normal.woff2', weight: '600', style: 'normal' },
    { path: '../../../public/fonts/lora-600-italic.woff2', weight: '600', style: 'italic' },
    { path: '../../../public/fonts/lora-700-normal.woff2', weight: '700', style: 'normal' },
  ],
  display: 'swap',
  preload: false,
  variable: '--font-tertiary',
});

const fonts = cn(fontPrimary.variable, fontSecondary.variable, fontTertiary.variable);

export const MotherhoodStandaloneEdge: Component<StandaloneEdgeProps> = ({ children }) => {
  return <StandaloneEdge className={fonts}>{children}</StandaloneEdge>;
};
